import { withValueVersion } from "../../WSUtils/withValueVersion";
import { BackendResponse } from "../BackendResponse";

export interface GetJobListUrlResponse extends BackendResponse {
  url: string;
}

export interface GetJobListUrlParameters {}

export type getJobListUrl = (
  args: GetJobListUrlParameters
) => GetJobListUrlResponse;

export const getJobListUrl: getJobListUrl = withValueVersion((args) => {
  return {
    url: `jobs`,
    ok: true,
    elapsedMilliseconds: 0,
    statusCode: 1200,
  };
}, false);
